import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=feffd4c4&"
import script from "./OrderHistory.vue?vue&type=script&lang=js&"
export * from "./OrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('feffd4c4')) {
      api.createRecord('feffd4c4', component.options)
    } else {
      api.reload('feffd4c4', component.options)
    }
    module.hot.accept("./OrderHistory.vue?vue&type=template&id=feffd4c4&", function () {
      api.rerender('feffd4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/report/OrderHistory.vue"
export default component.exports